import React from 'react';
import { api, profilePhotouploadDir } from '../../../config';

// Admin: shows a worker's current profile photo + every archived previous photo (identity trail).
// Loads via the web /graphql directly. Forward-only — only photos changed after rollout appear.
function gql(query, variables) {
  return fetch('/graphql', {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'include',
    body: JSON.stringify({ query, variables }),
  }).then(r => r.json());
}
const photoUrl = (pic) => `${api.apiEndpoint + profilePhotouploadDir}medium_${pic}`;

class WorkerPhotoGallery extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: true, current: null, history: [] };
  }

  componentDidMount() {
    const { userId } = this.props;
    if (!userId) { this.setState({ loading: false }); return; }
    gql(`query($u:String){ getWorkerPhotoHistory(userId:$u){ status currentPicture history{ id picture createdAt } } }`, { u: userId })
      .then(j => {
        const d = j && j.data && j.data.getWorkerPhotoHistory;
        this.setState({ loading: false, current: d && d.currentPicture, history: (d && d.history) || [] });
      })
      .catch(() => this.setState({ loading: false }));
  }

  render() {
    const { loading, current, history } = this.state;
    const box = { border: '1px solid #eee', borderRadius: 10, padding: '16px 18px', marginTop: 22 };
    if (loading) return <div style={box}>Loading photos…</div>;
    const thumb = (pic, label, highlight) => (
      <div key={label + pic} style={{ textAlign: 'center', marginRight: 14, marginBottom: 14 }}>
        <div style={{ width: 110, height: 110, borderRadius: 10, backgroundImage: `url(${photoUrl(pic)})`, backgroundSize: 'cover', backgroundPosition: 'center', border: highlight ? '2px solid #16a34a' : '1px solid #ddd' }} />
        <div style={{ fontSize: 12, color: highlight ? '#16a34a' : '#777', marginTop: 4, fontWeight: highlight ? 'bold' : 'normal' }}>{label}</div>
      </div>
    );
    return (
      <div style={box}>
        <div style={{ fontWeight: 'bold', fontSize: 16, marginBottom: 4 }}>Profile photo history</div>
        <div style={{ fontSize: 13, color: '#777', marginBottom: 14 }}>Current photo + every previous one, to confirm it's the same person. (Captured from now on.)</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start' }}>
          {current ? thumb(current, 'Current', true) : <div style={{ color: '#999' }}>No photo on file.</div>}
          {history.map((h) => thumb(h.picture, h.createdAt ? new Date(h.createdAt).toLocaleDateString() : 'Previous', false))}
        </div>
        {history.length === 0 ? <div style={{ fontSize: 13, color: '#999', marginTop: 2 }}>No previous photos recorded yet — they'll appear here as the worker changes their photo.</div> : null}
      </div>
    );
  }
}

export default WorkerPhotoGallery;
